import styled from 'styled-components';
import { screenMd } from 'constants/styles/breakpoints';
import { colors } from 'constants/styles/colors';

export const Title = styled.h5`
  display: flex;
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.default.colors.palette.Business_DarkThemeGeneralBackground};
`;

export const ReportingTitle = styled.span`
  color: var(--white, #fff);
  text-align: center;

  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
`;

export const Description = styled.div<{ customMargin?: string }>`
  font-size: 16px;
  font-weight: 450;
  line-height: 24px;
  white-space: pre-line;
  color: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyDarker};

  p {
    margin: 0;
  }
  ${({ customMargin }) =>
    customMargin &&
    `
		margin: ${customMargin};
	`}
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: auto;
  grid-gap: 10px;
`;

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  padding: 30px;
`;

export const SecureInput = styled.input<{ error: boolean }>`
  margin: 20px 0 0 0;
  font-weight: 400;

  ${({ error }) =>
    error &&
    `
    border: 1px solid red;
  `}
`;

export const ModalContainer = styled.div<{ lock?: boolean }>`
  height: 100%;
  background: var(--white, #fff);
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 100%;
  ${screenMd} {
    min-height: none;
    display: block;
    overflow: hidden;
    border-radius: 18px;
  }
  ${({ lock }) =>
    lock &&
    `
		opacity: 0.4;
		pointer-events: none;
	`}
`;

export const HeaderContainer = styled.div<{
  isSonar?: boolean;
  isRax?: boolean;
  isReporting?: boolean;
  isPopularReport?: boolean;
  isCertsOut?: boolean;
}>`
  width: 100%;
  height: 155px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(45.99deg, #863ad2 30%, #ef7d22 70%);
  flex-shrink: 0;
  padding: 30px;
  ${screenMd} {
    height: 155px;
    background: linear-gradient(45deg, #ef7d22 1%, #863ad2 30%, #190da0),
      linear-gradient(90deg, transparent 1%, #3c1aef 80%);
    flex-direction: column;
  }
  ${({ isSonar }) =>
    isSonar &&
    `
    padding: 30px;
    background: linear-gradient(45deg, #b44995 1%, #863ad2 22%, #190da0),
      linear-gradient(90deg, transparent 1%, #3c1aef 80%) !important;
	`}
  ${({ isRax }) =>
    isRax &&
    `
    background: var(--secondary-promo-purple-2) !important;
	`}
${({ isCertsOut }) =>
    isCertsOut &&
    `
    background: radial-gradient(circle at center, #bb2d68 0%, #a52f81 60%, #621ecf 100%) !important;
    padding: 30px;
  `}


  ${({ isPopularReport, isReporting }) =>
    (isPopularReport || isReporting) &&
    `
    position: relative;
    overflow: hidden;

    /* Top KPI Bar background */
    background: linear-gradient(90deg, #863ad2 3.58%, #5936e4 97.14%) !important;
    ${screenMd} {
      border-radius: 18px 18px 0 0;
    }
    padding: 0 30px;

    /* Orange glow ellipse */
    &::after {
      content: '';
      background: #ef7d22;
      filter: blur(92px);
      border-radius: 356px;
      opacity: 0.7;
  
      
      width: 356px;
      height: 331px;

      position: absolute;

      left: -40%;
      top: 70%;
      pointer-events: none;
      z-index: 0;
    }

    /* Vector overlay shape (SVG from design) */
    &::before {
      content: '';
      position: absolute;
      inset: 20% 0 0 0;
      pointer-events: none;
      z-index: 0;
      mix-blend-mode: overlay;
      background-repeat: no-repeat;
      background-position: center top;
      background-size: cover;
      background-image: url("data:image/svg+xml;utf8,${encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="564" height="155" viewBox="0 0 564 155" fill="none">
          <g style="mix-blend-mode:overlay" filter="url(#filter0_df_14152_230558)">
            <path d="M111.633 52.6465C70.0417 27.8597 45.6289 27.9917 0 52.6465V226H564V52.6465C548.617 42.868 540.529 43.5701 526.789 52.6465L488.849 77.9678C462.794 95.622 447.343 95.3751 418.075 77.9678L363.353 41.4467C335.309 25.9871 320.417 26.3831 295.498 41.4467L248.072 73.0983C209.128 99.4412 186.151 101.494 142.277 73.0983L111.633 52.6465Z" fill="url(#paint0_linear_14152_230558)"/>
            <path d="M111.633 52.6465C70.0417 27.8597 45.6289 27.9917 0 52.6465V226H564V52.6465C548.617 42.868 540.529 43.5701 526.789 52.6465L488.849 77.9678C462.794 95.622 447.343 95.3751 418.075 77.9678L363.353 41.4467C335.309 25.9871 320.417 26.3831 295.498 41.4467L248.072 73.0983C209.128 99.4412 186.151 101.494 142.277 73.0983L111.633 52.6465Z" stroke="#A793F6"/>
          </g>
          <defs>
            <filter id="filter0_df_14152_230558" x="-34.5" y="-4.5" width="633" height="265" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14152_230558"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14152_230558" result="shape"/>
              <feGaussianBlur stdDeviation="17" result="effect2_foregroundBlur_14152_230558"/>
            </filter>
            <linearGradient id="paint0_linear_14152_230558" x1="20.1139" y1="103.788" x2="512.559" y2="265.38" gradientUnits="userSpaceOnUse">
              <stop stop-color="#863AD2"/>
              <stop offset="1" stop-color="#5936E4"/>
            </linearGradient>
          </defs>
        </svg>`
      )}");
    }

    /* Ensure text stays above decorations */
    > h2, > span { position: relative; z-index: 1; }
  `}
  
  > h2 {
    color: var(--white, #ffffff);
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    white-space: pre-wrap;
    ${screenMd} {
      font-size: 24px;
      font-weight: 400;
    }
  }
`;

export const ModalContent = styled.div<{
  grow?: boolean;
  flexColumn?: boolean;
  sidePadding?: boolean;
}>`
  padding: 36px 0px 20px 0px;
  height: 100%;
  ${({ sidePadding }) =>
    sidePadding &&
    `
    padding: 36px 20px 20px;
	`}
  ${screenMd} {
    padding: 30px;
  }
  ${({ grow }) =>
    grow &&
    `
		flex-grow: 1;
	`}
  ${({ flexColumn }) =>
    flexColumn &&
    `
		display: flex;
		flex-direction: column;
	`}
`;

export const ModalSectionTitle = styled.h2<{ customMargin?: string }>`
  margin: 0 0 6px 0;
  padding: 0 10px;
  color: ${({ theme }) => theme.default.colors.fonts.dark};
  font-size: 20px;
  font-weight: 500;
  ${screenMd} {
    font-weight: 700;
    padding: 0;
  }
  ${({ customMargin }) =>
    customMargin &&
    `
		margin: ${customMargin};
	`}
`;

export { ModalSectionTitle as ModalLabels };

export const Input = styled.input<{ error?: boolean }>`
  height: 44px;
  font-size: 12px;
  padding: 15px 10px;
  display: block;
  border: none;
  border-radius: 10px;
  width: 100%;
  background: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyLighter};
  &:focus,
  &:active {
    outline: none;
  }
  &::placeholder {
    color: ${({ theme }) => theme.default.colors.fonts.darkGray};
  }
  ${({ error }) =>
    error &&
    `
				box-shadow: 0px 0px 0px 1px red;
			`}
  &:focus,
  &:active {
    border: 1px solid var(--lilac, #a793f6);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  }
`;

export const Textarea = styled.textarea<{ error?: boolean }>`
  resize: none;
  font-size: 12px;
  padding: 15px 10px;
  margin: 0;
  background: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyLighter};
  width: 100%;
  border: none;
  border-radius: 10px;
  min-height: 100px;
  font-family: var(--font-family-base);
  color: var(--black, #1e1e1e);
  &:focus {
    outline: none;
  }
  ${({ error }) =>
    error &&
    `
				box-shadow: 0px 0px 0px 1px red;
			`}
`;

export const InputContainer = styled.div`
  padding: 0px;
  ${screenMd} {
    padding: 0;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  margin-bottom: 10px;
  line-height: 20px;
  color: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyDarker};
`;

export const InputHelper = styled.label`
  font-size: 12px;
  line-height: 14px;
  margin-top: 10px;
  color: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyDarker};
`;

export const ModalSection = styled.div<{
  grow?: boolean;
  flexColumn?: boolean;
  toBottom?: boolean;
  customMargin?: string;
}>`
  margin: 15px 0;
  padding: 0 10px;
  ${screenMd} {
    padding: 0;
  }
  ${({ grow }) =>
    grow &&
    `
		flex-grow:
	`}
  ${({ flexColumn }) =>
    flexColumn &&
    `
		display: flex;
		flex-direction: column;
	`}
	${({ toBottom }) =>
    toBottom &&
    `
		margin-top: auto;
	`}
	${({ customMargin }) =>
    customMargin &&
    `
		margin: ${customMargin};
	`}
`;

export const ModalActions = styled.div`
  padding: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: auto;
  button {
    width: 50%;
  }
  ${screenMd} {
    justify-content: end;
    padding: 0px 30px 30px 30px;

    button {
      width: auto;
    }
  }
`;

export const FooterLeftText = styled.div`
  font-size: 10px;
  line-height: 12px;
  font-weight: 450;
  width: 60%;
  display: flex;
  gap: 5px;
  align-items: center;
  span {
    color: ${colors.fonts.darkGray};
  }
`;
